import {
	APP_ID,
	APP_INITIALIZER,
	ModuleWithProviders,
	NgModule,
	PLATFORM_ID,
} from '@angular/core';
import {
	BrowserModule,
	provideClientHydration,
	TransferState
} from '@angular/platform-browser';
import {
	ServiceWorkerModule as SWModule
} from '@angular/service-worker';
import {
	provideAnimationsAsync
} from '@angular/platform-browser/animations/async';
import {
	HttpClient,
	HttpClientModule
} from '@angular/common/http';
import {
	TranslateLoader,
	TranslateModule,
	TranslateService
} from '@ngx-translate/core';
import {
	CookieService
} from 'ngx-cookie-service';
import {
	FormsModule
} from '@angular/forms';
import {
	NgOptimizedImage,
	ViewportScroller
} from '@angular/common';

import {
	ProductService
} from '@main/products/services';
import {
	ProductComponent
} from '@main/products/components';
import {
	ScrollingModule
} from '@angular/cdk/scrolling';
import {
	AboutUsComponent
} from '@main/about-us/components';
import {
	HomeComponent
} from '@main/home/components';
import {
	ContactComponent
} from '@main/contact/components';

import {
	AppRoutingModules
} from './app-routing.module';
import {
	AppComponent
} from './app.component';
import {
	TranslateLoaderService
} from './translate-loader.factory';
import {
	CustomViewportScroller
} from './custom-viewport-scroller';

// eslint-disable-next-line @typescript-eslint/naming-convention
const ServiceWorkerModule: ModuleWithProviders<SWModule>
	= SWModule.register(
		'ngsw-worker.js',
		// { enabled:  process.env.ENV_NAME === 'prod'  }
		{ enabled:  true  }
	);

export function initializeTranslateService(translate: TranslateService) {
	return () => {
		const lang = 'vi';
		return translate.use(lang).toPromise();
	};
}

@NgModule({
	imports: [
		FormsModule,
		BrowserModule,
		HttpClientModule,

		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useClass: TranslateLoaderService,
				deps: [ HttpClient, TransferState, PLATFORM_ID ],
			},
		}),

		AppRoutingModules,
		NgOptimizedImage,
		ScrollingModule,

		ServiceWorkerModule,
	],
	declarations: [
		AppComponent,
		HomeComponent,
		ProductComponent,
		AboutUsComponent,
		ContactComponent,
	],
	providers: [
		CookieService,
		{
			provide: APP_ID,
			useValue: 'serverApp'
		},
		{	// Add APP_INITIALIZER for translation preloading
			provide: APP_INITIALIZER,
			useFactory: initializeTranslateService,
			deps: [TranslateService],
			multi: true,
		},
		{ provide: ViewportScroller, useClass: CustomViewportScroller },
		provideClientHydration(),
		provideAnimationsAsync(),

		ProductService
	],
	bootstrap: [ AppComponent ],
})
export class AppModule {}
